module.exports = __webpack_public_path__ + "media/images/svg/box-closed-229fb1f41f4a34cd8f901fee7256a779.svg";